export const GET_LIST_DANHSACHKIEMKHO = "GET_LIST_DANHSACHKIEMKHO";
export const GET_LIST_DANHSACHKIEMKHO_SUCCESS =
  "GET_LIST_DANHSACHKIEMKHO_SUCCESS";
export const GET_LIST_DANHSACHKIEMKHO_FAILURE =
  "GET_LIST_DANHSACHKIEMKHO_FAILURE";

export const UPDATE_SEARCHTDATA_DANHSACHKIEMKHO =
  "UPDATE_SEARCHTDATA_DANHSACHKIEMKHO";
